import React, { useState } from 'react';
import { Search } from 'lucide-react';
function parseDisplayDate(dateStr: string): Date {
  const months: Record<string, number> = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11
  };
  const parts = dateStr.split(' ');
  const day = parseInt(parts[0], 10);
  const month = months[parts[1]];
  const year = parseInt(parts[2], 10);
  return new Date(year, month, day);
}
const activityData = [{
  id: 'ACT-10001',
  date: '14 Feb 2026',
  time: '03:42 PM',
  userRole: 'Admin',
  actionType: 'Loan Disbursed',
  entityType: 'Disbursement',
  applicationId: 'APP-55678',
  loanId: 'LN-10234',
  repaymentId: null,
  description: 'Loan LN-10234 disbursed — PKR 500,000 via RAAST to Ali Traders'
}, {
  id: 'ACT-10002',
  date: '14 Feb 2026',
  time: '02:18 PM',
  userRole: 'Operations',
  actionType: 'Repayment Posted',
  entityType: 'Repayment',
  applicationId: 'APP-55678',
  loanId: 'LN-10234',
  repaymentId: 'RP-88924',
  description: 'Installment 4/12 for LN-10234 posted as paid — PKR 48,267'
}, {
  id: 'ACT-10003',
  date: '14 Feb 2026',
  time: '11:05 AM',
  userRole: 'Admin',
  actionType: 'Penalty Applied',
  entityType: 'Repayment',
  applicationId: 'APP-55678',
  loanId: 'LN-10234',
  repaymentId: 'RP-88921',
  description: 'Late penalty PKR 1,500 applied to overdue installment 5/12 of LN-10234'
}, {
  id: 'ACT-10004',
  date: '13 Feb 2026',
  time: '04:30 PM',
  userRole: 'Admin',
  actionType: 'Status Updated',
  entityType: 'Application',
  applicationId: 'APP-55678',
  loanId: 'LN-10234',
  repaymentId: null,
  description: 'Application APP-55678 status changed to Disbursement Ready'
}, {
  id: 'ACT-10005',
  date: '13 Feb 2026',
  time: '10:15 AM',
  userRole: 'Compliance',
  actionType: 'Status Updated',
  entityType: 'Application',
  applicationId: 'APP-55681',
  loanId: null,
  repaymentId: null,
  description: 'Compliance review completed for APP-55681 — Agri Corp application approved'
}, {
  id: 'ACT-10006',
  date: '12 Feb 2026',
  time: '09:00 AM',
  userRole: 'Operations',
  actionType: 'Loan Disbursed',
  entityType: 'Disbursement',
  applicationId: 'APP-55679',
  loanId: 'LN-10238',
  repaymentId: null,
  description: 'Loan LN-10238 disbursed — PKR 2,000,000 via IBFT to Sindh Logistics'
}, {
  id: 'ACT-10007',
  date: '11 Feb 2026',
  time: '05:12 PM',
  userRole: 'Admin',
  actionType: 'Repayment Posted',
  entityType: 'Repayment',
  applicationId: 'APP-55679',
  loanId: 'LN-10235',
  repaymentId: 'RP-88922',
  description: 'Installment 2/12 for LN-10235 posted as paid — PKR 48,867'
}, {
  id: 'ACT-10008',
  date: '10 Feb 2026',
  time: '01:45 PM',
  userRole: 'Compliance',
  actionType: 'Status Updated',
  entityType: 'Application',
  applicationId: 'APP-55679',
  loanId: 'LN-10235',
  repaymentId: null,
  description: 'Application APP-55679 moved to Active after disbursement confirmation'
}, {
  id: 'ACT-10009',
  date: '09 Feb 2026',
  time: '11:30 AM',
  userRole: 'Operations',
  actionType: 'Status Updated',
  entityType: 'Application',
  applicationId: 'APP-55682',
  loanId: null,
  repaymentId: null,
  description: 'New loan application APP-55682 submitted by Retail Mart'
}, {
  id: 'ACT-10010',
  date: '08 Feb 2026',
  time: '03:00 PM',
  userRole: 'Admin',
  actionType: 'Penalty Applied',
  entityType: 'Repayment',
  applicationId: 'APP-55681',
  loanId: 'LN-10237',
  repaymentId: 'RP-88925',
  description: 'Late penalty PKR 500 applied to overdue installment 3/12 of LN-10237'
}, {
  id: 'ACT-10011',
  date: '07 Feb 2026',
  time: '09:20 AM',
  userRole: 'Admin',
  actionType: 'Loan Disbursed',
  entityType: 'Disbursement',
  applicationId: 'APP-55681',
  loanId: 'LN-10237',
  repaymentId: null,
  description: 'Loan LN-10237 disbursed — PKR 300,000 via RAAST to Punjab Agro'
}, {
  id: 'ACT-10012',
  date: '05 Feb 2026',
  time: '02:55 PM',
  userRole: 'Compliance',
  actionType: 'Status Updated',
  entityType: 'Application',
  applicationId: 'APP-55680',
  loanId: 'LN-10236',
  repaymentId: null,
  description: 'Final compliance sign-off for APP-55680 — Tech Solutions loan cleared'
}, {
  id: 'ACT-10013',
  date: '03 Feb 2026',
  time: '10:00 AM',
  userRole: 'Operations',
  actionType: 'Status Updated',
  entityType: 'Loan',
  applicationId: 'APP-55680',
  loanId: 'LN-10236',
  repaymentId: null,
  description: 'Loan LN-10236 marked as fully settled — all installments cleared'
}, {
  id: 'ACT-10014',
  date: '01 Feb 2026',
  time: '08:45 AM',
  userRole: 'Admin',
  actionType: 'Status Updated',
  entityType: 'Application',
  applicationId: 'APP-55681',
  loanId: null,
  repaymentId: null,
  description: 'New loan application APP-55681 created for Agri Corp'
}, {
  id: 'ACT-10015',
  date: '28 Jan 2026',
  time: '04:10 PM',
  userRole: 'Operations',
  actionType: 'Repayment Posted',
  entityType: 'Repayment',
  applicationId: 'APP-55680',
  loanId: 'LN-10236',
  repaymentId: 'RP-88923',
  description: 'Installment 1/6 for LN-10236 posted as paid — PKR 125,000'
}];
export function ActivityLogPage() {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [userRole, setUserRole] = useState('All');
  const [actionType, setActionType] = useState('All');
  const [entityType, setEntityType] = useState('All');
  const [loanIdSearch, setLoanIdSearch] = useState('');
  const [repaymentIdSearch, setRepaymentIdSearch] = useState('');
  const filteredData = activityData.filter(item => {
    let matchesDate = true;
    if (dateFrom && dateTo) {
      const itemDate = parseDisplayDate(item.date);
      const from = new Date(dateFrom + 'T00:00:00');
      const to = new Date(dateTo + 'T23:59:59');
      matchesDate = itemDate >= from && itemDate <= to;
    }
    const matchesRole = userRole === 'All' || item.userRole === userRole;
    const matchesAction = actionType === 'All' || item.actionType === actionType;
    const matchesEntity = entityType === 'All' || item.entityType === entityType;
    const matchesLoanId = !loanIdSearch || (item.loanId || '').toLowerCase().includes(loanIdSearch.toLowerCase());
    const matchesRepaymentId = !repaymentIdSearch || (item.repaymentId || '').toLowerCase().includes(repaymentIdSearch.toLowerCase());
    return matchesDate && matchesRole && matchesAction && matchesEntity && matchesLoanId && matchesRepaymentId;
  });
  return <div className="space-y-6" data-id="element-527">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-528">
        <div data-id="element-529">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-530">
            System Activity Log
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-531">
            Centralized audit trail of all system-level actions for compliance
            and monitoring.
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-532">
        <div className="flex flex-col sm:flex-row gap-4 items-end flex-wrap" data-id="element-533">
          <div className="w-full sm:w-auto" data-id="element-534">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-535">
              Date Range
            </label>
            <div className="flex gap-2" data-id="element-536">
              <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-537" />
              <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-538" />
            </div>
          </div>

          <div className="w-full sm:w-40" data-id="element-539">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-540">
              User Role
            </label>
            <select value={userRole} onChange={e => setUserRole(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-541">
              <option value="All" data-id="element-542">All Roles</option>
              <option value="Admin" data-id="element-543">Admin</option>
              <option value="Operations" data-id="element-544">Operations</option>
              <option value="Compliance" data-id="element-545">Compliance</option>
            </select>
          </div>

          <div className="w-full sm:w-48" data-id="element-546">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-547">
              Action Type
            </label>
            <select value={actionType} onChange={e => setActionType(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-548">
              <option value="All" data-id="element-549">All Actions</option>
              <option value="Loan Disbursed" data-id="element-550">Loan Disbursed</option>
              <option value="Repayment Posted" data-id="element-551">Repayment Posted</option>
              <option value="Status Updated" data-id="element-552">Status Updated</option>
              <option value="Penalty Applied" data-id="element-553">Penalty Applied</option>
            </select>
          </div>

          <div className="w-full sm:w-44" data-id="element-554">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-555">
              Entity Type
            </label>
            <select value={entityType} onChange={e => {
            setEntityType(e.target.value);
            if (e.target.value !== 'Repayment') setRepaymentIdSearch('');
          }} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-556">
              <option value="All" data-id="element-557">All Entities</option>
              <option value="Application" data-id="element-558">Application</option>
              <option value="Loan" data-id="element-559">Loan</option>
              <option value="Repayment" data-id="element-560">Repayment</option>
              <option value="Disbursement" data-id="element-561">Disbursement</option>
            </select>
          </div>

          <div className="w-full sm:w-40" data-id="element-562">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-563">
              Loan ID
            </label>
            <div className="relative rounded-md shadow-sm" data-id="element-564">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-565">
                <Search className="h-4 w-4 text-gray-400" aria-hidden="true" data-id="element-566" />
              </div>
              <input type="text" className="block w-full rounded-md border-gray-300 pl-10 focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" placeholder="LN-..." value={loanIdSearch} onChange={e => setLoanIdSearch(e.target.value)} data-id="element-567" />
            </div>
          </div>

          {entityType === 'Repayment' && <div className="w-full sm:w-40" data-id="element-568">
              <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-569">
                Repayment ID
              </label>
              <div className="relative rounded-md shadow-sm" data-id="element-570">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-571">
                  <Search className="h-4 w-4 text-gray-400" aria-hidden="true" data-id="element-572" />
                </div>
                <input type="text" className="block w-full rounded-md border-gray-300 pl-10 focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" placeholder="RP-..." value={repaymentIdSearch} onChange={e => setRepaymentIdSearch(e.target.value)} data-id="element-573" />
              </div>
            </div>}
        </div>
      </div>

      {/* Table */}
      <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-lg overflow-hidden" data-id="element-574">
        <div className="overflow-x-auto" data-id="element-575">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-576">
            <thead className="bg-gray-50" data-id="element-577">
              <tr data-id="element-578">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-579">
                  Activity ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-580">
                  Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-581">
                  Time
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-582">
                  User Role
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-583">
                  Action Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-584">
                  Entity Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-585">
                  Application ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-586">
                  Loan ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-587">
                  Repayment ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-588">
                  Description
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white" data-id="element-589">
              {filteredData.map(item => <tr key={item.id} className="hover:bg-gray-50 transition-colors" data-id="element-590">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-591">
                    {item.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-592">
                    {item.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-593">
                    {item.time}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-594">
                    {item.userRole}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-595">
                    {item.actionType}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-596">
                    {item.entityType}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-597">
                    {item.applicationId}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-598">
                    {item.loanId || '—'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-599">
                    {item.repaymentId || '—'}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500 max-w-xs truncate" data-id="element-600">
                    {item.description}
                  </td>
                </tr>)}
              {filteredData.length === 0 && <tr data-id="element-601">
                  <td colSpan={10} className="px-6 py-8 text-center text-sm text-gray-500" data-id="element-602">
                    No activity records match the selected filters.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}